import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { formManager } from '../../config/configuration/react';
import { Form } from '../../config/Form/FormEntity';
import { FormApi } from '../../config/Form/FormApi';

export const useForm = (initFormId) => {
  const { search } = useLocation();
  const [formId, setFormId] = useState(initFormId);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [form, setForm] = useState(null);
  const formEntity = new Form(form);

  const resetFormData = async () => {
    setIsLoading(true);
    try {
      if (formId) {
        await formManager.delete(formId);
        setForm(await FormApi.get(formId));
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getForm = async () => {
    setIsLoading(true);
    try {
      if (formId) setForm(await formManager.getFormFromLocal(formId));
    } catch (e) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const updateAfterIndexedDBevent = (e) => {
    if (e.key && e.key.includes(`${formId}`)) getForm();
  };

  useEffect(() => {
    if (search && search.split('?')[1] === 'resetForm=true') resetFormData();
    window.addEventListener('storage', updateAfterIndexedDBevent);
    return () => {
      window.removeEventListener('storage', updateAfterIndexedDBevent);
    };
  }, []);

  useEffect(() => {
    getForm();
  }, [formId]);

  return { form, setFormId, isLoading, error, formEntity, getForm };
};
